import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss'
})
export class StatusBadgeComponent implements ICellRendererAngularComp {

  params: any;
  value: string = '';
  badgeClass: string = '';
  agInit(params: any): void {

    this.params = params;
    this.value = params.valueFormatted || params.value;

    console.log(params);


    switch (this.value) {
      case 'Booked':
      case 'booked': //booked
        this.badgeClass = 'ag-grid-pill-info';
        break;
      case 'Delivered':
      case 'customer_delivered': //customer_delivered
        this.badgeClass = 'ag-grid-pill-warning';
        break;
      case 'Provider Delivered':
      case 'provider_delivered':  //provider_delivered
        this.badgeClass = 'ag-grid-pill-success';
        break;
      case 'In Transit':
      case 'provider_collected': //provider_collected
        this.badgeClass = 'ag-grid-pill-success';
        break;
      default:
        this.badgeClass = 'ag-grid-pill-secondary';
        break;
    }
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params;
    this.value = params.value;
    return true;
  }
}
